document.addEventListener("DOMContentLoaded", function () {
    const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    productForms.forEach((form) => {
        const formId = form.id;
        const quantityInputs = document.querySelectorAll(`input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`);
        if (quantityInputs.length === 0) return;
        form.addEventListener("submit", function (e) {
            const activeQuantityInput = quantityInputs[0];
            const quantity = parseInt(activeQuantityInput.value) || 1;
            form.querySelectorAll('input[type="hidden"][name="quantity"]').forEach((input) => {
                input.remove();
            });
            const qtyInput = document.createElement("input");
            qtyInput.type = "hidden";
            qtyInput.name = "quantity";
            qtyInput.value = quantity;
            form.appendChild(qtyInput);
        });
    });

    function handleResponsiveProductTitles() {
        const productTitles = document.querySelectorAll(".shop-product-title[data-font-size][data-mobile-font-size]");

        function adjustAllTitles() {
            const isMobile = window.innerWidth <= 767;
            productTitles.forEach((title) => {
                const size = isMobile ?
                    title.getAttribute("data-mobile-font-size") :
                    title.getAttribute("data-font-size");
                title.style.setProperty("font-size", `${size}px`, "important");
            });
        }

        // Un seul listener pour tous les titres
        adjustAllTitles();

        if (!window.titleResizeHandlerAdded) {
            window.addEventListener("resize", adjustAllTitles);
            window.titleResizeHandlerAdded = true;
        }
    }
    handleResponsiveProductTitles();
    function animateFaqPanel(item, open) {
        const answer = item.querySelector(".faq-answer");
        if (!answer) return;

        const onTransitionEnd = (event) => {
            if (event.propertyName !== "max-height") return;
            answer.removeEventListener("transitionend", onTransitionEnd);
            if (open && item.classList.contains("active")) {
                answer.style.maxHeight = "none";
            } else if (!open) {
                answer.style.maxHeight = "0px";
            }
        };

        if (open) {
            item.classList.add("active");
            answer.style.maxHeight = "0px";
            requestAnimationFrame(() => {
                answer.style.maxHeight = `${answer.scrollHeight}px`;
            });
            answer.addEventListener("transitionend", onTransitionEnd);
            return;
        }

        const currentHeight = answer.scrollHeight;
        answer.style.maxHeight = `${currentHeight}px`;
        requestAnimationFrame(() => {
            item.classList.remove("active");
            answer.style.maxHeight = "0px";
        });
        answer.addEventListener("transitionend", onTransitionEnd);
    }

    function closeFaqItem(item) {
        const question = item.querySelector(".faq-question");
        if (question) question.setAttribute("aria-expanded", "false");
        animateFaqPanel(item, false);
    }

    function openFaqItem(item) {
        const question = item.querySelector(".faq-question");
        if (question) question.setAttribute("aria-expanded", "true");
        animateFaqPanel(item, true);
    }

    function initFaqAccordions() {
        const faqContainers = document.querySelectorAll(".product-faq");
        faqContainers.forEach((faqContainer) => {
            const faqId = faqContainer.id;
            if (!faqId) return;
            const faqItems = faqContainer.querySelectorAll(".faq-item");
            const innerFaqContainer = faqContainer.querySelector(".faq-container");
            const isAccordion = innerFaqContainer && innerFaqContainer.getAttribute("data-accordion") === "true";
            const isMinimal = faqContainer.classList.contains("product-faq--minimal");
            faqItems.forEach((item) => {
                const question = item.querySelector(".faq-question");
                if (!question) return;
                if (!question.hasAttribute("data-click-listener-added")) {
                    question.setAttribute("data-click-listener-added", "true");
                    question.addEventListener("click", () => {
                        const isActive = item.classList.contains("active");
                        if (isMinimal) {
                            if (isAccordion && !isActive) {
                                faqItems.forEach((otherItem) => {
                                    if (otherItem !== item && otherItem.classList.contains("active")) {
                                        closeFaqItem(otherItem);
                                    }
                                });
                            }
                            if (isActive) {
                                closeFaqItem(item);
                            } else {
                                openFaqItem(item);
                            }
                            return;
                        }
                        if (isAccordion && !isActive) {
                            faqItems.forEach((otherItem) => {
                                otherItem.classList.remove("active");
                                const otherQuestion = otherItem.querySelector(".faq-question");
                                if (otherQuestion) otherQuestion.setAttribute("aria-expanded", "false");
                            });
                        }
                        item.classList.toggle("active");
                        question.setAttribute("aria-expanded", item.classList.contains("active") ? "true" : "false");
                    });
                }
            });
        });
    }
    initFaqAccordions();
    const readMoreLinks = document.querySelectorAll(".shop-read-more");
    const readLessLinks = document.querySelectorAll(".shop-read-less");
    readMoreLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.closest(".shop-product-description");
            parent.querySelector(".shop-truncated-description").style.display = "none";
            parent.querySelector(".shop-full-description").style.display = "block";
        });
    });
    readLessLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault();
            const parent = this.closest(".shop-product-description");
            parent.querySelector(".shop-truncated-description").style.display = "block";
            parent.querySelector(".shop-full-description").style.display = "none";
        });
    });


});
